/**
 * Enregistre le service worker (`/sw.js`) : affichage des notifications Web Push, ouverture de l'appli au
 * toucher et, depuis le lot AW, ouverture de l'appli sans réseau (coquille gardée). Il ne garde aucune réponse
 * d'API : les données gardées sont dans IndexedDB, côté appli (`stores/offline`).
 */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
      /* sans service worker, l'appli marche ; seul le push manque */
    });
  });
}
